import React from 'react';
import { motion } from 'framer-motion';
import { ThumbsUp, MessageCircle, Share2, MoreHorizontal } from 'lucide-react';
export function FacebookWall() {
  const comments = [{
    name: 'María José Herrera',
    time: 'Hace 2 horas',
    text: '¡VENDÍ MI PRIMER PDF! 😭😭😭 Lo que más me gustó fue que la IA escribió casi todo por mí. Solo tuve que revisar y darle mi toque personal. Mi esposo no me creía cuando le enseñé el comprobante jajaja',
    likes: 47,
    avatar: 'MH',
    replies: [{
      name: 'Valentina Ríos',
      text: 'Felicidades amiga!! 🎉 yo voy en el día 4, los prompts de IA son una maravilla',
      likes: 8,
      avatar: 'VR'
    }, {
      name: 'Rosa Gutiérrez',
      text: 'Eso!! 💪 la IA me ayudó a escribir todo en una tarde, increíble',
      likes: 5,
      avatar: 'RG'
    }]
  }, {
    name: 'Camila Rodríguez',
    time: 'Hace 3 horas',
    text: 'Pensé que sería difícil, pero con los prompts de IA fue como chatear por WhatsApp 😅 literal copié, pegué y ya tenía mi contenido listo. Mañana lo publico en mis estados!!',
    likes: 34,
    avatar: 'CR'
  }, {
    name: 'Sofía Martínez',
    time: 'Hace 4 horas',
    text: 'Hice mi PDF en una tarde, la IA es el socio que necesitaba 💕 Por fin algo que SÍ funciona y no me tomó semanas.',
    likes: 21,
    avatar: 'SM'
  }, {
    name: 'Isabella Vargas',
    time: 'Hace 5 horas',
    text: 'Publiqué en mis estados de WhatsApp y ya me escribieron 4 personas preguntando precio 🥺 Lo mejor es que la IA me ayudó hasta con los textos de venta. Esto funciona de verdad',
    likes: 56,
    avatar: 'IV',
    replies: [{
      name: 'Luciana Mendoza',
      text: 'Amigaaa los prompts son oro!! yo pensé que necesitaba saber escribir bien pero la IA hace todo 🙈',
      likes: 3,
      avatar: 'LM'
    }, {
      name: 'Isabella Vargas',
      text: '@Luciana exacto! solo hazlo, la IA te guía paso a paso 😂',
      likes: 7,
      avatar: 'IV'
    }]
  }, {
    name: 'Daniela Flores',
    time: 'Hace 5 horas',
    text: 'Llevo meses queriendo empezar algo y siempre me trababa con la escritura. Con la IA por fin entendí que no necesito ser experta, solo necesito los prompts correctos 🤯',
    likes: 29,
    avatar: 'DF'
  }, {
    name: 'Fernanda López',
    time: 'Hace 6 horas',
    text: 'Día 3 y ya tengo mi PDF completo 📄 La IA redactó los capítulos y yo solo ajusté detalles. Mañana armo la oferta con los guiones que vienen incluidos',
    likes: 38,
    avatar: 'FL'
  }, {
    name: 'Andrea Castillo',
    time: 'Hace 7 horas',
    text: 'Le pedí a la IA que me escribiera el contenido mientras cocinaba el almuerzo. Cuando terminé de cocinar, mi PDF estaba listo 🔥🔥🔥',
    likes: 15,
    avatar: 'AC'
  }, {
    name: 'Patricia Morales',
    time: 'Hace 7 horas',
    text: 'Mi hermana me lo recomendó y no le creía... pero cuando vi cómo la IA generaba todo el contenido en minutos, le debo una disculpa jajaja 😂 esto es real',
    likes: 22,
    avatar: 'PM'
  }, {
    name: 'Gabriela Núñez',
    time: 'Hace 8 horas',
    text: 'Yo que pensaba que necesitaba saber redactar bien y resulta que la IA hace el trabajo pesado 📱 Solo necesitas el celular y los prompts',
    likes: 18,
    avatar: 'GN'
  }, {
    name: 'Laura Jiménez',
    time: 'Hace 8 horas',
    text: '¿Alguien más se sorprendió de lo fácil que es usar la IA con estos prompts? Porque yo sí 😭💕 pensé que era cosa de ingenieros',
    likes: 41,
    avatar: 'LJ',
    replies: [{
      name: 'Carmen Delgado',
      text: 'YOOO 🙋‍♀️ literal es como mandarle un mensaje a una amiga que sabe de todo jajaja',
      likes: 12,
      avatar: 'CD'
    }]
  }, {
    name: 'Ana Belén Torres',
    time: 'Hace 9 horas',
    text: 'Lo mejor es que no tuve que mostrar mi cara en ningún momento Y la IA hizo el contenido por mí. Doble victoria 🙌',
    likes: 33,
    avatar: 'AT'
  }, {
    name: 'Mariana Salazar',
    time: 'Hace 10 horas',
    text: 'Mi esposo: "¿y eso funciona?" Yo: *le enseño cómo la IA escribió 20 páginas en 30 minutos* Mi esposo: "¿cuándo haces el segundo?" 😂😂',
    likes: 67,
    avatar: 'MS',
    replies: [{
      name: 'Elena Paredes',
      text: 'JAJAJAJA el mío igual!! ahora quiere que le enseñe a usar los prompts 🤣',
      likes: 9,
      avatar: 'EP'
    }]
  }, {
    name: 'Claudia Vega',
    time: 'Hace 11 horas',
    text: 'Soy mamá de 3 y trabajo medio tiempo. La IA me ahorró semanas de escritura. Con los prompts maestros terminé todo en ratitos libres 💪',
    likes: 25,
    avatar: 'CV'
  }, {
    name: 'Natalia Herrera',
    time: 'Hace 12 horas',
    text: '$6 dólares por un sistema que incluye IA para crear tu producto. Mejor inversión de mi vida. Punto.',
    likes: 44,
    avatar: 'NH'
  }, {
    name: 'Alejandra Ruiz',
    time: 'Hace 13 horas',
    text: 'Ya van 3 ventas esta semana 🤩 La biblioteca de prompts es lo mejor, la IA hace el 80% del trabajo',
    likes: 52,
    avatar: 'AR'
  }, {
    name: 'Teresa Campos',
    time: 'Hace 14 horas',
    text: 'La parte de los prompts maestros es ORO PURO. Le dices a la IA exactamente qué hacer y te entrega contenido profesional 🤯',
    likes: 19,
    avatar: 'TC'
  }, {
    name: 'Diana Peña',
    time: 'Hace 15 horas',
    text: 'Recién compré, voy en el día 1 y la IA ya me encontró mi nicho perfecto en 5 minutos!! 🚀',
    likes: 11,
    avatar: 'DP'
  }];
  return <section className="bg-slate-50 py-16 md:py-24 px-4" data-id="element-11">
      <div className="max-w-2xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-13">
          <h2 className="text-3xl md:text-4xl text-dark font-display font-extrabold tracking-headline" data-id="element-14">
            Lo Que Dicen Nuestras Mamás Digitales
          </h2>
          <p className="text-slate-500 mt-2" data-id="element-15">
            Comentarios reales de nuestra comunidad
          </p>
        </motion.div>

        {/* Facebook Post Container */}
        <div className="bg-white rounded-xl shadow-md border border-slate-200 overflow-hidden" data-id="element-16">
          {/* Post Header */}
          <div className="p-4 flex items-center justify-between" data-id="element-17">
            <div className="flex items-center gap-3" data-id="element-18">
              <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold" data-id="element-19">
                MI
              </div>
              <div data-id="element-20">
                <p className="font-bold text-dark text-sm" data-id="element-21">Sistema Mamá IA</p>
                <p className="text-xs text-slate-500" data-id="element-22">2d · 🌎</p>
              </div>
            </div>
            <MoreHorizontal className="text-slate-400" data-id="element-23" />
          </div>

          {/* Post Content */}
          <div className="px-4 pb-3" data-id="element-24">
            <p className="text-dark text-[15px]" data-id="element-25">
              ¿Quién ya usó la IA para crear su producto? 🙌 Cuéntanos cómo te
              fue! Queremos leer sus historias 💕
            </p>
          </div>

          {/* Post Image */}
          <div className="bg-slate-100 aspect-video relative overflow-hidden" data-id="element-26">
            <img src="https://cdn.magicpatterns.com/uploads/rvyr4WVBS4pMk6CY4WGdBm/landingmamaia_competenciamentor_v2.webp" alt="Sistema Mamá IA Mockups" className="w-full h-full object-cover object-top" data-id="element-27" />
          </div>

          {/* Post Stats */}
          <div className="px-4 py-2.5 flex items-center justify-between border-b border-slate-100" data-id="element-28">
            <div className="flex items-center gap-1" data-id="element-29">
              <div className="w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center z-10" data-id="element-30">
                <ThumbsUp className="w-3 h-3 text-white fill-white" data-id="element-31" />
              </div>
              <div className="w-5 h-5 rounded-full bg-red-500 flex items-center justify-center -ml-2" data-id="element-32">
                <span className="text-white text-[10px]" data-id="element-33">❤️</span>
              </div>
              <span className="text-slate-500 text-[13px] ml-1" data-id="element-34">234</span>
            </div>
            <div className="text-slate-500 text-[13px]" data-id="element-35">
              22 comentarios · 12 compartidos
            </div>
          </div>

          {/* Post Actions */}
          <div className="px-4 py-1 flex items-center justify-between border-b border-slate-100" data-id="element-36">
            <button className="flex-1 flex items-center justify-center gap-2 py-2 text-slate-500 hover:bg-slate-50 rounded-md transition-colors font-semibold text-[13px]" data-id="element-37">
              <ThumbsUp className="w-4 h-4" data-id="element-38" /> Me gusta
            </button>
            <button className="flex-1 flex items-center justify-center gap-2 py-2 text-slate-500 hover:bg-slate-50 rounded-md transition-colors font-semibold text-[13px]" data-id="element-39">
              <MessageCircle className="w-4 h-4" data-id="element-40" /> Comentar
            </button>
            <button className="flex-1 flex items-center justify-center gap-2 py-2 text-slate-500 hover:bg-slate-50 rounded-md transition-colors font-semibold text-[13px]" data-id="element-41">
              <Share2 className="w-4 h-4" data-id="element-42" /> Compartir
            </button>
          </div>

          {/* Comments Section */}
          <div className="p-4 bg-white" data-id="element-43">
            <p className="text-slate-500 font-semibold text-[13px] mb-4" data-id="element-44">
              Ver los 22 comentarios
            </p>

            <div className="space-y-4" data-id="element-45">
              {comments.map((comment, idx) => <div key={idx} className="flex gap-2" data-id="element-46">
                  <div className="w-8 h-8 rounded-full bg-slate-200 flex-shrink-0 flex items-center justify-center text-xs font-bold text-slate-500" data-id="element-47">
                    {comment.avatar}
                  </div>
                  <div className="flex-1" data-id="element-48">
                    <div className="bg-slate-100 rounded-2xl px-3 py-2 inline-block" data-id="element-49">
                      <p className="font-bold text-[13px] text-dark" data-id="element-50">
                        {comment.name}
                      </p>
                      <p className="text-[13px] text-dark" data-id="element-51">{comment.text}</p>
                    </div>
                    <div className="flex items-center gap-3 mt-1 ml-2 text-[12px] font-bold text-slate-500" data-id="element-52">
                      <button className="hover:underline" data-id="element-53">Me gusta</button>
                      <button className="hover:underline" data-id="element-54">Responder</button>
                      <span className="font-normal text-slate-400" data-id="element-55">
                        {comment.time}
                      </span>
                      {comment.likes > 0 && <div className="flex items-center gap-1 ml-auto" data-id="element-56">
                          <div className="w-4 h-4 rounded-full bg-blue-500 flex items-center justify-center" data-id="element-57">
                            <ThumbsUp className="w-2.5 h-2.5 text-white fill-white" data-id="element-58" />
                          </div>
                          <span className="font-normal text-slate-500" data-id="element-59">
                            {comment.likes}
                          </span>
                        </div>}
                    </div>

                    {/* Replies */}
                    {comment.replies && comment.replies.map((reply, rIdx) => <div key={rIdx} className="flex gap-2 mt-2" data-id="element-60">
                          <div className="w-6 h-6 rounded-full bg-slate-200 flex-shrink-0 flex items-center justify-center text-[10px] font-bold text-slate-500" data-id="element-61">
                            {reply.avatar}
                          </div>
                          <div data-id="element-62">
                            <div className="bg-slate-100 rounded-2xl px-3 py-2 inline-block" data-id="element-63">
                              <p className="font-bold text-[13px] text-dark" data-id="element-64">
                                {reply.name}
                              </p>
                              <p className="text-[13px] text-dark" data-id="element-65">
                                {reply.text}
                              </p>
                            </div>
                            <div className="flex items-center gap-3 mt-1 ml-2 text-[12px] font-bold text-slate-500" data-id="element-66">
                              <button className="hover:underline" data-id="element-67">
                                Me gusta
                              </button>
                              <button className="hover:underline" data-id="element-68">
                                Responder
                              </button>
                              {reply.likes > 0 && <div className="flex items-center gap-1 ml-auto" data-id="element-69">
                                  <div className="w-4 h-4 rounded-full bg-blue-500 flex items-center justify-center" data-id="element-70">
                                    <ThumbsUp className="w-2.5 h-2.5 text-white fill-white" data-id="element-71" />
                                  </div>
                                  <span className="font-normal text-slate-500" data-id="element-72">
                                    {reply.likes}
                                  </span>
                                </div>}
                            </div>
                          </div>
                        </div>)}
                  </div>
                </div>)}
            </div>

            <div className="mt-4 flex gap-2" data-id="element-73">
              <div className="w-8 h-8 rounded-full bg-slate-200 flex-shrink-0" data-id="element-74"></div>
              <div className="flex-1 bg-slate-100 rounded-full px-4 py-2 text-[13px] text-slate-500" data-id="element-75">
                Escribe un comentario...
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}